import { IntlShape } from 'react-intl';

// eslint-disable-next-line
export const getBillingCountryError = (_: IntlShape['formatMessage']) => '';
